import React from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
  ListSubheader,
  Box,
  Typography,
  Avatar,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  AddBox as AddBoxIcon,
  PersonAdd as PersonAddIcon,
  Payment as PaymentIcon,
  CardMembership as CardMembershipIcon,
  Style as StyleIcon,
  Analytics as AnalyticsIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSidebar } from '../../context/SidebarContext';

export const drawerWidth = 250;

const DrawerHeader = () => (
  <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
      <CardMembershipIcon sx={{ mr: 1, fontSize: '1.6rem', color: 'primary.main' }} />
      <Typography variant="h6" color="text.primary" sx={{ fontWeight: 'bold' }}>
          Cardify
      </Typography>
  </Box>
);

export const SideMenuContent = () => {
  const { role, user, isPaymentEnabled } = useAuth();

  const adminLinks = (
    <>
      <ListItemButton component={Link} to="/admin/dashboard">
        <ListItemIcon><DashboardIcon /></ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
      <ListItemButton component={Link} to="/admin/user-management">
        <ListItemIcon><PersonAddIcon /></ListItemIcon>
        <ListItemText primary="User Management" />
      </ListItemButton>
      <ListItemButton component={Link} to="/admin/cards">
        <ListItemIcon><StyleIcon /></ListItemIcon>
        <ListItemText primary="Card Management" />
      </ListItemButton>
      <ListItemButton component={Link} to="/admin/analytics">
        <ListItemIcon><AnalyticsIcon /></ListItemIcon>
        <ListItemText primary="Analytics" />
      </ListItemButton>
      <ListItemButton component={Link} to="/admin/analytics-history">
        <ListItemIcon><ScheduleIcon /></ListItemIcon>
        <ListItemText primary="Analytics History" />
      </ListItemButton>
      {isPaymentEnabled && (
        <ListItemButton component={Link} to="/admin/payments">
          <ListItemIcon><PaymentIcon /></ListItemIcon>
          <ListItemText primary="Payments" />
        </ListItemButton>
      )}
    </>
  );

  const userLinks = (
    <>
      <ListItemButton component={Link} to="/dashboard">
        <ListItemIcon><DashboardIcon /></ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
      <ListItemButton component={Link} to="/analytics">
        <ListItemIcon><AnalyticsIcon /></ListItemIcon>
        <ListItemText primary="Analytics" />
      </ListItemButton>
      <ListItemButton component={Link} to="/analytics-history">
        <ListItemIcon><ScheduleIcon /></ListItemIcon>
        <ListItemText primary="Analytics History" />
      </ListItemButton>
      {isPaymentEnabled && (
        <ListItemButton component={Link} to="/payment">
          <ListItemIcon><PaymentIcon /></ListItemIcon>
          <ListItemText primary="Payment" />
        </ListItemButton>
      )}
    </>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <DrawerHeader />
      <Divider />
      <List sx={{ flexGrow: 1 }}>
        {role === 'admin' ? adminLinks : userLinks}
      </List>
      <Divider />
      {user && (
        <Box sx={{ p: 2, mt: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: 'secondary.main' }}>
                {user?.username?.[0].toUpperCase()}
            </Avatar>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {user?.username}
            </Typography>
            </Box>
        </Box>
      )}
    </Box>
  );
};

export default SideMenuContent; 